<template>
  <b-card no-body class="card-accent-primary">
    <b-card-header class="p-0">
      <b-row class="d-flex align-items-center">
        <b-col class="ml-3">
          <b>
            Consulta de Siniestros
          </b>
        </b-col>
        <b-col class="text-right">
          <b-button class="btn-success m-2" @click="exportarShow" :disabled="loading">Exportar...</b-button>
          <b-modal id="exportar-modal" title="Exportar" hide-footer>
      <label for="report-select" class="my-2">Formato de reporte:</label>
      <b-select id="report-select" class="mb-2 mr-sm-2 mb-sm-0" v-model="formato" 
                :options="opcionesExport">            
      </b-select>      
      <p class="my-2">Propiedades a mostar en el reporte:</p>
      <b-form-checkbox-group class="ml-5" v-model="reportCols" v-for="(col, index) in selCols" :key="index">                
        <b-form-checkbox class="mb-1" :value="col.key">{{col.label}}</b-form-checkbox>                
      </b-form-checkbox-group>
      <hr>       
        <b-button id="exportararchivoButton" variant="success" @click="exportTo" :disabled="reportCols.length==0">Exportar Reporte</b-button>              
    </b-modal>
          <!--span class="m-3">Exportar:</span>
          <b-button :disabled="!data.length" class="m-1" variant="success" size="sm" @click="$emit('export', 'pdf')">
            PDF
          </b-button>
          <b-button :disabled="!data.length" class="m-1" variant="success" size="sm" @click="$emit('export', 'csv')">
            CSV
          </b-button>
          <b-button :disabled="!data.length" class="m-1" variant="success" size="sm" @click="$emit('export', 'xls')">
            XLS
          </b-button-->          
        </b-col>
      </b-row>
    </b-card-header>
    <b-table
      :items="data"
      :fields="columns"
      :busy="loading"
      :filter="terms"
      striped
      small
      responsive
      head-variant="light"
      class="m-0"
      :current-page="currentPage"
      :per-page="10"
    >
      <div slot="table-busy" class="text-center text-info my-2">
        <b-spinner class="align-middle mx-2"></b-spinner>
        <strong>Obteniendo resultados...</strong>
      </div>

      <div slot="estado" slot-scope="data">
        <b-badge :variant="colorByStatus(data.item.estado)">{{ data.item.estado }}</b-badge>
      </div>
    </b-table>

    <b-card-footer class="px-1 py-2">
      <b-row>
        <b-col>
          <b-col>
            <small class="text-muted">Mostrando {{ rowsPerPage > totalRows ? totalRows : rowsPerPage }} de {{ totalRows }} resultados</small>
          </b-col>
        </b-col>
        <b-col>
          <b-pagination
            size="sm"
            :total-rows="totalRows"
            :per-page="perPage"
            v-model="currentPage"
            prev-text="Anterior"
            next-text="Siguiente"
            @change="$emit('paginate', $event)"
          />
        </b-col>
        <b-col></b-col>
      </b-row>
    </b-card-footer>
  </b-card>
</template>

<script>
import { columns } from '@/pages/Siniestros/helpers';

export default {
  name: 'SiniesTableComponent',
  props: {
    data: {
      type: Array,
      required: true
    },
    totalRows: {
      type: Number,
      required: true
    },
    rowsPerPage: {
      type: Number,
      required: true
    },
    loading: {
      type: Boolean
    }
  },
  data() {
    return {      
      formato: 'pdf',
      currentPage: 1,
      perPage: 10,
      columns: columns.map(x => x.checked?x.key:null).filter(y => y != null),
      reportCols: columns.map(x => x.checked?x.key:null).filter(y => y != null),
      selCols: columns,
      terms: '',
      opcionesExport: [
        { text: 'PDF', value: 'pdf' },        
        { text: 'XLS', value: 'xls' },
        { text: 'CSV', value: 'csv' },
      ]
    };
  },

  methods: {
    exportTo(){
      this.$bvModal.hide('exportar-modal');
      this.$emit('export', this.formato, this.reportCols);      
    },
    exportarShow(){
       this.$bvModal.show('exportar-modal');
    },
    colorByStatus(value) {
      if (value == 'PAGADO') {
        return 'success';
      } else if (value == 'ABIERTO') {
        return 'info';
      } else if (value == 'CERRADO') {
        return 'light';
      } else if (value == 'EN LIQUIDACION') {
        return 'warning';
      } else if (value == 'RECHAZADO') {
        return 'danger';
      }
      return 'secondary';
    }
  }
};
</script>
